/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from 'context/appContext';
import '@whereby.com/browser-sdk/embed';
import { paths } from '../../routes';

function VideoCall() {
  const [{ user }] = useAppContext();
  const navigate = useNavigate();
  const location = useLocation();

  const displayName = user?.firstName ? `${user?.firstName} ${user?.lastName}` : 'River Provider';

  const params = new URLSearchParams(location.search);

  const link = params.get('link');
  const returnLink = params.get('returnLink');

  React.useEffect(() => {
    const wherebyElement = document.querySelector('whereby-embed');

    if (!wherebyElement) {
      return undefined;
    }

    const leaveCallListener = (event: any) => {
      const url = new URL(returnLink || `${window.location.origin}${paths.HOME_URL_PATH}`);
      const output = '';

      switch (event.type) {
        case 'leave':
          url.searchParams.set('successMsg', 'Video call ended successfully');
          window.location.replace(url.toString());
          // output = `got event ${JSON.stringify({ type: event.type, detail: event.detail })}\n`;
          break;
        case 'join':
          // output = `got event ${JSON.stringify({ type: event.type, detail: event.detail })}\n`;
          break;
        case 'participant_join': // This is Patient Joining the call
          // output = `got event ${JSON.stringify({ type: event.type, detail: event.detail })}\n`;
          break;
        case 'participant_leave': // This is Patient Leaving the call
          // output = `got event ${JSON.stringify({ type: event.type, detail: event.detail })}\n`;
          break;
        default:
          break;
      }
    };

    wherebyElement.addEventListener('join', leaveCallListener);

    wherebyElement.addEventListener('leave', leaveCallListener);

    wherebyElement.addEventListener('participant_join', leaveCallListener);

    wherebyElement.addEventListener('participant_leave', leaveCallListener);

    return () => {
      wherebyElement.removeEventListener('join', leaveCallListener);
      wherebyElement.addEventListener('leave', leaveCallListener);
      wherebyElement.addEventListener('participant_join', leaveCallListener);
      wherebyElement.addEventListener('participant_leave', leaveCallListener);
    };
  }, [navigate, returnLink]);

  return (
    <div className="relative pt-8 tablet:pt-14 pb-14 flex flex-col justify-center items-center">
      <div className="w-full laptop:w-[80%]">
        <div className="whereby bg-[#6769AA] rounded-2xl w-full h-[500px] tablet:h-[600px]">
          {link && (
            <whereby-embed room={link} minimal="on" displayName={displayName} leaveButton="on" />
          )}
        </div>
      </div>
    </div>
  );
}

export default VideoCall;
